import React from 'react';
import Typography from '@material-ui/core/Typography';

import IKImage from '../../../IKImage/IKImage';
import { BREAKPOINTS_VALUES } from '../../../../theme';
import useStyles from './styles';

const BottomItem = ({ title, image }) => {
  const classes = useStyles();

  return (
    <div key={image} className={classes.bottomItem}>
      <div className={classes.bottomItemImageWrapper}>
        <IKImage
          className={classes.bottomItemImg}
          path={image}
          draggable={false}
          alt={title}
          srcset={[{ width: 65 }, { width: 40 }]}
          sizes={`(max-width:${BREAKPOINTS_VALUES['md']}px) 40px, 65px`}
        />
      </div>
      <Typography className={classes.bottomItemText}>{title}</Typography>
    </div>
  );
};

export default BottomItem;
